import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { formatNumber } from '@/lib/format'

export function ActiveCustomersCard({ activeCustomers }: { activeCustomers: number }): React.ReactElement {
  return (
    <Card className="shadow-none border-border/80">
      <CardHeader>
        <CardDescription>Aktiva kunder</CardDescription>
        <CardTitle className="text-5xl font-serif text-primary">{formatNumber(activeCustomers)}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">Kunder med ett aktivt abonnemang just nu.</p>
      </CardContent>
    </Card>
  )
}
